const dropZoneStyle = ({ palette, shape, spacing }) => ({
  "@keyframes progress": {
    "0%": {
      backgroundPosition: "0 0",
    },
    "100%": {
      backgroundPosition: "-70px 0",
    },
  },
  root: {
    position: "relative",
    minHeight: spacing(44),
    backgroundColor: "#FCFCFC",
    border: "dashed",
    borderColor: palette.grey[200],
    borderRadius: shape.borderRadius,
    boxSizing: "border-box",
    cursor: "pointer",
    overflow: "hidden",
    padding: spacing(2),
    borderWidth: 2,
  },
  active: {
    animation: "$progress 2s linear infinite !important",
    // eslint-disable-next-line max-len
    backgroundImage: `repeating-linear-gradient(-45deg, ${palette.background.paper}, ${palette.background.paper} 25px, ${palette.divider} 25px, ${palette.divider} 50px)`,
    backgroundSize: "150% 100%",
    border: "solid",
    borderColor: palette.primary.light,
  },
  invalid: {
    // eslint-disable-next-line max-len
    backgroundImage: `repeating-linear-gradient(-45deg, ${palette.error.light}, ${palette.error.light} 25px, ${palette.error.dark} 25px, ${palette.error.dark} 50px)`,
    borderColor: palette.error.main,
  },
  error: {
    borderColor: palette.error.main,
  },
  disabled: {
    cursor: "not-allowed",
  },
  textContainer: {
    textAlign: "center",
  },
  label: {
    marginBottom: spacing(2),
  },
  icon: {
    display: "inline-block",
    width: spacing(15),
    height: spacing(15),
    color: palette.text.disabled,
    marginBottom: spacing(1),
  },
  title: {
    color: palette.text.secondary,
  },
  subtitle: {
    color: palette.text.disabled,
    marginBottom: spacing(2),
  },
  button: {
    marginBottom: spacing(2),
  },
  caption: {},
});

export default dropZoneStyle;
